<template>
  <div class="validate-user" :class="state.type">
    <div class="title-img" :class="state.locale"></div>
    <div class="form" v-if="!state.cpUserInfo.cpUserId">
      <div class="form-item">
        <div class="form-item-label user-id" @click="openUserGuide">
          <i class="icon-question"></i>
          {{ $t('payment.validateUser.desc') }}
        </div>
        <div class="form-item-input">
          <HistoryUserIdInput
            v-model="state.userId"
            :locale="state.locale"
            :placeholder="$t('payment.validateUser.enterUserId')"
          />
        </div>
        <div class="form-item-button">
          <button class="btn submit-btn" @click="handleSubmit">{{ $t('payment.validateUser.submit') }}</button>
        </div>
      </div>
    </div>
    <div class="validate-user-success" v-else>
      <div class="user-info">
        <div class="user-info-item">
          <span class="user-info-item-label">
            {{ $t('payment.userDialog.id') }}: 
          </span>
          <span class="user-info-item-value">
            {{ state.cpUserInfo.cpUserId }}
          </span>
        </div>
        <div class="user-info-item">
          <span class="user-info-item-label">
            {{ $t('payment.userDialog.name') }}: 
          </span>
          <span class="user-info-item-value">
            {{ state.cpUserInfo.cpNickName }}
          </span>
        </div>
      </div>
      <button class="reset-btn" :class="{ blue: state.cpUserInfo.cpUserId }" @click="resetUserInfo">{{ $t('payment.userDialog.cancelInput') }}</button>
    </div>
    <Dialog v-model="state.dialog.visible" type="validateUser">
      <div class="dialog-content">
        <div class="info">
          <div class="info-item">
            <div class="info-item-label">
              {{ $t('payment.userDialog.id') }}: 
            </div>
            <div class="info-item-value">
              {{ state.tempCpUserInfo.cpUserId }}
            </div>
          </div>
          <div class="info-item">
            <div class="info-item-label">
              {{ $t('payment.userDialog.name') }}: 
            </div>
            <div class="info-item-value">
              {{ state.tempCpUserInfo.cpNickName }}
            </div>
          </div>
        </div>
        <div class="desc">
          {{ $t('payment.userDialog.confirmText') }}
        </div>
        <div class="btn-box">
          <AccumButton type="blue" @click="handleConfirm">{{ $t('payment.userDialog.confirmInput') }}</AccumButton>
          <AccumButton type="green" @click="handleCancel">{{ $t('payment.userDialog.cancelInput') }}</AccumButton>
        </div>
      </div>
    </Dialog>
    <div v-if="state.showImageViewer">
      <el-image-viewer
        v-if="state.showImageViewer"
        hide-on-click-modal
        :url-list="state.imageList"
        :initial-index="0"
        :z-index="9999"
        teleported
        @close="closeImageViewer"
      />
    </div>
  </div>
</template>

<script setup>
import useValidateUser from '../script'
import HistoryUserIdInput from '../HistoryUserIdInput/index.vue'
import Dialog from '@/components/Dialog/ActAccum'
import AccumButton from '@/views/act/accum/components/AccumButton'
import { ElImageViewer } from 'element-plus'
import { defineEmits } from 'vue'
const emit = defineEmits(['resetUserInfo', 'getUserInfoSuccess', 'dialogOpen'])
const { state, handleSubmit, handleConfirm, handleCancel, resetUserInfo, openUserGuide, closeImageViewer } = useValidateUser(emit, 'accum')
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
